import { AfterViewInit, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowService } from './workflow.service';
import { HotToastService } from '@ngneat/hot-toast';
import { FormsModule } from '@angular/forms';
import { ActivationComponent } from '../components/activation/activation.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SocketService } from '../utility/socket.service';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { BrnMenuTriggerDirective } from '@spartan-ng/ui-menu-brain';
import { NgOptimizedImage } from '@angular/common'
import moment from 'moment';
import * as env from 'environments/environment'


import {
  HlmMenuComponent,
  HlmMenuGroupComponent,
  HlmMenuItemDirective,
  HlmMenuItemIconDirective,
  HlmMenuItemSubIndicatorComponent,
  HlmMenuLabelComponent,
  HlmMenuSeparatorComponent,
  HlmMenuItemCheckComponent,
  HlmMenuShortcutComponent,
  HlmMenuItemCheckboxDirective,
  HlmSubMenuComponent,
} from '@spartan-ng/ui-menu-helm';
import { BrnSelectImports } from '@spartan-ng/ui-select-brain';
import { HlmSelectImports } from '@spartan-ng/ui-select-helm';
import { CardSkeletonComponent } from '../components/skeleton/card-skeleton/card-skeleton.component';
import { HlmLabelDirective } from '@spartan-ng/ui-label-helm';
import { HlmSwitchComponent } from '../../../../../spartan_libs/ui-switch-helm/src';
import { Navbar } from '../layout/navbar/navbar';
import { LazyLoaderComponent } from '../components/lazy-loader/lazy-loader.component';
import { DataCollectorService } from '../utility/data_collector.service';
import { WorkflowBreadcrumbService } from '../service/workflow-breadcrumb.service';
import { HlmDialogService } from '../../../../../spartan_libs/ui-dialog-helm/src';
import { TemplatesComponent } from '../components/templates/templates.component';
import { Title } from '@angular/platform-browser';
import { AlertComponent } from '../components/alert/alert.component';
import { ImportWorkflowComponent } from '../components/import-workflow/import-workflow.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { NodeIconComponent } from './components/node-icon/node-icon.component';

@Component({
  selector: 'app-workflows',
  standalone: true,
  imports: [ 
    CommonModule, 
    FormsModule, 
    LazyLoaderComponent, 
    MatDialogModule, 
    MatMenuModule, 
    HlmButtonDirective,
    HlmMenuComponent,
    BrnMenuTriggerDirective,
    HlmMenuGroupComponent,
    HlmMenuItemDirective,
    HlmMenuItemIconDirective,
    HlmMenuItemSubIndicatorComponent,
    HlmMenuLabelComponent,
    HlmMenuSeparatorComponent,
    HlmMenuItemCheckComponent,
    HlmMenuShortcutComponent,
    HlmMenuItemCheckboxDirective,
    HlmSubMenuComponent,
    NgOptimizedImage,
    BrnSelectImports,
    HlmSelectImports,
    CardSkeletonComponent,
    HlmSwitchComponent,
    HlmLabelDirective,
    ImportWorkflowComponent,
    TranslateModule,
    NodeIconComponent
  ],
  templateUrl: './workflows.component.html',
  styleUrls: ['./workflows.component.scss'],
  providers: [DataCollectorService, SocketService]
})
export class WorkflowsComponent implements OnInit {

  @ViewChild('sortDropdown')sortDropdown: ElementRef;
  @ViewChild('sortDropDownTrigger')sortDropDownTrigger: ElementRef;
  private readonly _hlmDialogService = inject(HlmDialogService);


  env: any
  workflows: any = [];
  currentPage: number = 1;
  totalPages: number = 1;
  totalRecords: number = 0;
  count: number = 12
  filter: any = {
    sort: 'DESC',
    sort_by: 'created_at',
    limit: this.count,
    page: this.currentPage,
  }
  sort: any = {
    'created_at': 'Created At',
    'workflow_name': 'Workflow Name'
  }
  showLoader: boolean = false;
  keyword: string = '';
  breadcrumbData: Navbar = {
    heading: 'Workflow Builder',
    buttons: [
      {
        label: 'Create Workflow',
        icon: 'plus',
        type: 'primary'
      }
    ]
  };
  shimmerArr: any[] = Array.from({length: 8}).fill(0);
  switchState: any = [];
  needsAttentionWorkflows: any[] = [];
  needsAttentionCurrentPage: number = 1;
  needsAttentionLimit: number = 3;
  needsAttentionTotalRecords: number = 0;

  constructor(
    private _workFlowService: WorkflowService,
    private _dataCollectorService: DataCollectorService,
    private _toast: HotToastService,
    private _dialog: MatDialog,
    private _router: Router,
    private _title: Title,
    private localisationService: LocalisationService
  ) {

  }



  redirectToHistory(workflow: any): void {
    this._router.navigate(['/workflow-builder/workflows',workflow.workflow_uid],{
      queryParams: {
        state: 'EXECUTION_HISTORY'
      }
    });
  }

  openTemplates(): void {
    const dialogRef = this._hlmDialogService.open(TemplatesComponent, {
      context: {
          data: {},
      },
      contentClass: 'sm:!max-w-[950px] min-w-[55vw] w-[55vw] data-[state=open]:slide-in-from-bottom duration-300 template-modal p-0',
    });

    dialogRef.closed$.subscribe((res: any) => {
      if (res) {
      }
    });
  }

  importWorkflow(): void {
    const dialogRef = this._hlmDialogService.open(ImportWorkflowComponent, {
      context: {
        data: {}
      },
      contentClass: 'sm:!max-w-[950px] min-w-[55vw] w-[55vw] data-[state=open]:slide-in-from-bottom duration-300 template-modal p-0'
    })

    dialogRef.closed$.subscribe((res: any) => {
      if(res){
        this.clearSearch();

      }
    })
  }

  sortByWorkflow(sortBy: string): void {
    this.currentPage = 1;
    this.filter['sort_by'] = sortBy;
    const filter = {...this.filter}
    if(this.keyword){
      filter['filter.keyword'] = this.keyword;
    }
    this.filter = filter;
    this.getWorkFlows(filter)
  }

  sortWorkflow(sort: string): void {
    this.currentPage = 1;
    this.filter['sort'] = sort;
    const filter = {...this.filter}
    if(this.keyword){
      filter['filter.keyword'] = this.keyword;
    }
    this.filter = filter
    this.getWorkFlows(filter)
  }

  searchKeyword(): void {
    this.currentPage = 1;
    this.workflows = [];
    this.showLoader = true;
    const filter = {...this.filter};
    filter['filter.keyword'] = this.keyword;
    this.filter = filter;
    this.getWorkFlows(filter);
  }

  clearSearch(): void {
    this.keyword = '';
    this.currentPage = 1;
    const filter = {...this.filter};
    filter['filter.keyword'] = this.keyword;
    this.filter = filter;
    this.workflows = [];
    this.showLoader = true;
    this.getWorkFlows(filter);
  }

  loadWorkflows(): void {
    this.currentPage++;
    const filter = {...this.filter}
    filter.page = this.currentPage;
    this.showLoader = true;
    this.getWorkFlows(filter)
  }

  getTimeAgo(date: string): string {
    return moment(date).fromNow(true)
  }

  setActivation(state: 'active' | 'deactive' | 'delete', index: number, event: Event) {
    this._workFlowService.setActivation(state, (res: boolean) => {
      if(res){
        this.count = this.currentPage * this.count;
        this.currentPage = 1;
        this.filter['limit'] = this.count;
        this.filter['page'] = this.currentPage;
        this.filter['filter.keyword'] = this.keyword;
        if(state === 'active'){
          this.activateWorkflow(this.workflows[index]['workflow_uid'], index, state);
        }else if(state === 'deactive'){
          this.deactivateWorkflow(this.workflows[index]['workflow_uid'], index, state);
        }else{
          this.deleteWorkflow(index)
        }
      }else{
        if(state === 'active'){
          this.switchState[index] = false;
        }else{
          this.switchState[index] = true;
        }
      }
    }, AlertComponent, this.workflows[index]?.workflow_name)

  }

  openWorkflow(workflow: any): void {
    this._router.navigateByUrl('/workflow-builder/workflows/'+ workflow?.workflow_uid)
  }

  activateWorkflow(uid: string, index: number, state: 'active' | 'deactive'): void {
    this._dataCollectorService.putData(this._workFlowService.apiUrls.workflows + `/${uid}/activate`,{})
      .subscribe((res: any) => {
        const filter = {...this.filter};
        this.showLoader = true;
        this._toast.success(res?.message);
        this._workFlowService.workflowChange$.next(true);
        this.getWorkFlows(filter);
      }, (err: any) => {
        if(state === 'active'){
          this.switchState[index] = false;
        }else{
          this.switchState[index] = true;
        }
      })
  }

  deactivateWorkflow(uid: string, index: number, state: 'active' | 'deactive'): void {
    this._dataCollectorService.putData(this._workFlowService.apiUrls.workflows + `/${uid}/deactivate`,{})
      .subscribe((res: any) => {
        const filter = {...this.filter};
        this.showLoader = true;
        this._toast.success(res?.message);
        this._workFlowService.workflowChange$.next(true);
        this.getWorkFlows(filter);
      }, (err: any) => {
        if(state === 'active'){
          this.switchState[index] = false;
        }else{
          this.switchState[index] = true;
        }
      })
  }

  deleteWorkflow(index: number): void {
    this._dataCollectorService.deleteData(this._workFlowService.apiUrls.workflows + `/${this.workflows[index]['workflow_uid']}`)
      .subscribe((res: any) => {
        const filter = {...this.filter};
        this.showLoader = true;
        this._toast.success(res?.message);
        this.getWorkFlows(filter);
      })
  }

  getNeedsAttentionWorkflows(): void {
    this._dataCollectorService.getData(this._workFlowService.apiUrls.need_attention+'/workflows', {
      'page': this.needsAttentionCurrentPage,
      'limit': this.needsAttentionLimit
    })
      .subscribe({
        next: (res: any) => {
          if(this.needsAttentionCurrentPage > 1) {
            this.needsAttentionWorkflows  = [...this.needsAttentionWorkflows, ...res?.data?.data]
          }else{
            this.needsAttentionWorkflows = res?.data?.data;
          }
          this.needsAttentionTotalRecords = res?.data?.total_records;
        }
      })
  }

  acknowledgeNeedsAttention(workflow): void {
    this._dataCollectorService.postData(this._workFlowService.apiUrls.need_attention + '/acknowledge',{
      workflow_uid: workflow?.workflow_uid,
      acknowledge_all: true
    })
    .subscribe({
      next: (res: any) => {
        this._toast.success(`Workflow '${workflow?.workflow_name}' has been acknowledged successfully`);
        this.getNeedsAttentionWorkflows();
      }
    })
  }

  getWorkFlows(filter: any): void {
    this._dataCollectorService.getData(this._workFlowService.apiUrls.workflows, filter)
      .subscribe((res: any) => {
        this.showLoader = false;
        this.totalPages = res?.total_pages;
        this.totalRecords = res?.total_records;
        if(this.currentPage === 1){
          this.workflows = res?.data;
          
          if(this.workflows.length > 12){
            this.count = 12
            this.filter['limit'] = this.count;
            this.currentPage = Math.ceil(this.workflows.length/this.count);
          }
          this.filter['page'] = this.currentPage;
        }else{
          this.workflows.push(...res?.data);
        }
        this.workflows.forEach((flow: any, index: number)=>{
          if(flow?.is_active){
            this.switchState[index] = flow?.is_active;
          }
        })

      }, (err: any) => {
        this._toast.error(err?.data?.message);
      })
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.workflows = [];
    this._title.setTitle('Zuper Pro - Workflow')
    this.env = env.environment;
    this.showLoader = true;
    this.getWorkFlows(this.filter);
    this.getNeedsAttentionWorkflows();
  }


}
